import React from 'react'
import styleAboutCosmetic from './CSS/styleAboutCosmetic.css'
import cosmetic1 from "./images/cosmetic1.jpg";
import cosmetic2 from "./images/cosmetic2.jpg";

export default function About_cosmetic() {
    return (
        <div>
            <section id="overview">
                <h1 class="heading_big">Cosmetic Issues</h1>
                <h3 class="heading_content">Polycystic Ovarian Syndrome Acne Help</h3>
                <p class="content">Acne is an indicator of a primary hormonal imbalance in the body. Acne is the root cause of the facial flaws, for which an individual requires polycystic ovarian syndrome acne help. Women with PCOS often suffer from acne and oily skin as a manifestation of hormonal imbalance. Excessive androgens or male hormones cause acne in women with PCOS. PCOS cystic acne is typical in appearance, presenting as large, red, and deep breakouts on your skin-a a severe form of acne resulting from hormonal imbalance. PCOS-related acne tends to be concentrated in “hormonally sensitive,” areas-especially the lower one-third part of the face. This includes cheeks, jawline, chin, and upper neck. Stress, along with a carbohydrate-rich diet, can exacerbate this condition further.

Dealing with Acne in PCOS women can be a distressing experience. In order to effectively manage these complications, it is important to collectively approach this problem with polycystic ovarian syndrome acne help from your gynecologist and dermatologist both.</p>

<img
    src={cosmetic1}
    class="img_overview"
/>

<h3 class="heading_content">Polycystic Ovarian Syndrome Acne Treatment</h3>
<p class="content">Oral Contraceptive Drugs, Insulin Sensitizing Drugs, Anti-androgen drugs are generally used for polycystic ovarian syndrome acne treatment. Your doctor will also guide you on appropriate PCOS acne treatment strategies and medications to be followed while dealing with this aspect of PCOS management. For PCOS acne treatment, it is important to Handle your testosterone Stages and focus on lowering inflammation.

When does a woman need polycystic ovarian syndrome acne treatment?

PCOS acne treatment is needed when the following symptoms are evident:

acne
(hirsutism) hair growing on your face, chest, or back
unbalanced menstruation
weight put-on or struggle in losing weight
(acanthosis nigricans) reinforcements of dark skin on the back of your neck or other areas</p>

<img
    src={cosmetic2}
    class="img_overview"
/>

<h3 class="heading_content">Polycystic Ovarian Syndrome and Unwanted Hair Growth (Hirsutism)</h3>
<p class="content">The unwanted hair growth or hirsutism is because of the secretion of male hormones, which are secreted higher than normal. Typically, PCOS sufferers have coarse, darker hair growing over the face, chin, neck, chest, back, or limbs. The excess hair can be gotten rid of through shaving, waxing, depilatories, and tweezing, but these methods have their own limitations and demand extra effort or time, which can be highly inconvenient and cause mental distress for the women in her efforts to do away with the excess hair. Laser hair removal is one of the most successful ways to stop hair growth.</p>
            </section>
        </div>
    )
}